export const itemNameMap: { [key: string]: string } = {
  messageType: 'チャット種別は',
  message: '送信メッセージは',
  currentContractCarName: '現在の契約自動車車名は',
  currentContractCarRegistrationNumber: '現在の契約自動車 登録番号下４桁は',
  isLongTermContract: '長期契約フラグは',
  updatedContractCarName: '変更後の契約自動車車名は',
  yearAndMonthOfFirstRegistration: '初度登録年月は',
  carModel: '型式は',
  chassisNumber: '車台番号は',
  carType: '用途車種は',
  baseLocationForUse: '使用の本拠地は',
  carOwner: '車両所有者（漢字）は',
  carOwnerKana: '車両所有者（カナ）は',
  outOfPocketFeeFirstTime: '自己負担額(初回)は',
  outOfPocketFeeAfterSecondTime: '自己負担額(二回目以降)は',
  updatedContractCarRegistrationNumber: '変更後の契約自動車登録番号は',
  updatedCarInsuranceFee: '変更後の車両保険金額は',
  carInsuranceFeeNextYear: '（長期）次年度車両保険金額は',
  carInsuranceFeeThirdYear: '（長期）３年度目車両保険金額は',
  isPersonalAndInsuranceStartTerm: '個人・法人・保険始期選択は',
  updatedDriverSpecialContract: '変更後の運転者限定条件は',
  updatedDriverAgeConditionSpecialContract: '変更後の年齢条件は',
  addOrMinus: '追加・返戻は',
  updatedInsuranceFee: '変更保険料',
  updatedMonthlyInsuranceFee: '変更後月払保険料は',
  aboutUpdatedInsuranceFee: '変更後保険料については',
  aboutUpdatedInsuranceFeeDetail: '変更後保険料については',
  updatedInsuranceFeeOfNextYear: '（長期）次年度変更後保険料は',
  paymentMethodOfNextYear: '（長期）次年度変更後保険料の単位は',
  updatedInsuranceFeeOfThirdYear: '（長期）３年度目変更後保険料は',
  paymentMethodOfThirdYear: '（長期）３年度目変更後保険料の単位は',
  newCarSpecialContractAddOrMinus: '【新価特約】追加・返戻は',
  newCarSpecialContractUpdatedInsuranceFee: '【新価特約】変更保険料は',
  newCarSpecialContractUpdatedMonthlyInsuranceFee:
    '【新価特約】変更後月払保険料は',
  newCarSpecialContractUpdatedInsuranceFeeOfNextYear:
    '【新価特約】（長期）次年度変更後保険料は',
  newCarSpecialContractPaymentMethodOfNextYear:
    '【新価特約】（長期）次年度変更後保険料の単位は',
  newCarSpecialContractUpdatedInsuranceFeeOfThirdYear:
    '【新価特約】（長期）３年度目変更後保険料は',
  newCarSpecialContractPaymentMethodOfThirdYear:
    '【新価特約】（長期）３年度目変更後保険料の単位は',
  remarks: 'カスタマーセンターからのご連絡事項は',
};
